import { LocaleMessages } from 'vue-i18n';

const i18n: LocaleMessages = {
  app: {
    contactBanner: {
      title: 'S Elixírem cestujete vždy výhodněji',
      subtitle:
        'Řekněte nám, o čem sníte. Naše travel specialistky pro Vás připraví nabídku na míru — nezávazně a zdarma.',
      button: 'Kontaktujte nás',
    },
  },
};

export default i18n;
